// ========== plugin import =========== //
import React,{useEffect, useState} from 'react'
import { Link, useLocation  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faRocketchat  } from '@fortawesome/free-brands-svg-icons';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { values } from 'lodash';
import axios from 'axios'
// import { toast } from 'react-toastify';
// ========== component import =========== //
import AlertMessage from '../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';

const Careers = () => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    // ------- define all state ------- //
    const [ formSubmitRes, setFormSubmitRes ] = useState('');

    return (
        <>
            <section className="hero-area hero-area-background">
                <div className="container">
                    <div className="text-center px-20">
                        <div className="section-heading">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim fs-4x text-grad-1 pb-6">
                                    Careers
                                </h2>
                            </div>
                            <div className="text-wrapper mt-0 mb-20">
                                <p className="text has_fade_anim mt-3 fs-1 text-grad-3">
                                    We are always fond of Engineers who have passion to work on cutting edge AI, creative new age marketeers, and people who have strong linguistics skills.  You can reach us in confidence at <a href="mailto:careers@truvoice.ai" className="text-grad">careers@truvoice.ai.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export {Careers}